/**
 * threadAddPeopleCopy — the ONE people panel's copy (2026-09-08).
 *
 * A leaf on purpose: the composer and add-people HOOKS need these strings,
 * and importing them through the panel component pulled the panel's render
 * dependencies (sender identity → group message docs → firebase/auth) into
 * every hook consumer, including jsdom unit tests. Code authors chrome and
 * failure copy only (D9); nothing here is model content.
 */
export const ADD_PEOPLE_COPY = {
  title: 'Add people',
  composeTitle: 'New thread',
  composeHint: 'Name it if you like, pick who is in it, or start with just you.',
  /**
   * The name at creation (2026-09-13). Optional on purpose — Miles: "if the
   * user does not name the thread on the pop up, create a new thread. That's
   * fine." An unnamed thread reads "new thread" to everyone and then takes the
   * name its summary determines, the same name for all of them.
   */
  composeNameLabel: 'Thread name',
  composeNamePlaceholder: 'Name this thread (optional)',
  composeNameHint: "Everyone starts with this name. Leave it blank and Prest0n names it from what you talk about.",
  assistantName: 'Prest0n',
  assistantAlwaysHere: 'In this thread — replies per the @ mention setting',
  assistantRemoved: 'Not in this thread — nobody can summon Prest0n here',
  assistantComposeOn: 'In this thread',
  assistantComposeOff: 'Not in this thread',
  removeAssistant: 'Remove',
  addAssistantBack: 'Add back',
  removingAssistant: 'Removing…',
  addingAssistant: 'Adding…',
  /**
   * Removing a PERSON (Miles, 2026-09-15: an owner could not take anyone out
   * of a group thread — the rows under "Already in this thread" carried no
   * control at all). One control per row for whoever may manage the thread
   * (creator ‖ owner ‖ admin ‖ `threads.manage`, the server's own predicate),
   * a two-step confirm because a removed person loses the thread from their
   * list at once, and a note instead of a button on the person who started
   * the thread — the server refuses that removal, so no button offers it.
   */
  removePerson: 'Remove',
  removingPerson: 'Removing…',
  removeAsk: 'Remove from this thread?',
  removeConfirm: 'Yes, remove',
  removeCancel: 'Keep',
  startedThread: 'Started this thread',
  removeFailed: "Couldn't remove that person.",
  cannotRemoveCreator: "The person who started this thread can't be removed from it.",
  manageRefusal:
    "You can see who is here, but changing who is in this thread needs the person who started it, or a workspace owner or admin.",
  workspaceMismatch:
    "You're looking at a different workspace than your account is switched to right now — switch workspaces to add people here.",
  searchPlaceholder: 'Search people…',
  noMatches: 'No one matches that.',
  loading: 'Loading workspace members…',
  emptyNoRoster: "You're the only person in this workspace so far.",
  emptyNoRosterHint: 'Invite a teammate and they can join your threads as soon as they accept.',
  emptyAllIn: 'Everyone in this workspace is already in this thread.',
  alreadyHere: 'Already in this thread',
  notYetAvailable: 'Not available yet',
  invited: 'Invited — waiting for them to accept',
  invitedHint: "They'll appear here as soon as they accept. You can resend or cancel in Team & Roles.",
  inviteExpired: 'Invitation expired — resend it in Team & Roles',
  invitePending: "Hasn't accepted yet",
  manageTeam: 'Invite a teammate',
  retry: 'Try again',
  add: 'Add',
  adding: 'Adding…',
  close: 'Close',
  justMe: 'Just me',
  startThread: 'Start thread',
  starting: 'Starting…',
  startFailed: "Couldn't start the thread — try again.",
  roleContributor: 'Contributor',
  roleViewer: 'Read-only',
  roleHintContributor: 'Can read and post in this thread.',
  roleHintViewer: 'Can read this thread but not post.',
} as const;
